import React from 'react'
import Collapsible from 'react-collapsible'
import { Set } from 'immutable'

import { Selection } from 'src/helpers'
import { AccountFragment, Category, PlanFragment } from 'src/graphql'
// relative imports
import { Plan } from '../../types'
import PlanTile from './PlanTile'
import Feature from './Feature'
import RoundedFooter from './RoundedFooter'
import { planDetails } from '../../constants'

import {
  cardBoxShadow as boxShadow,
  categoryBackground,
  style,
} from './pricingTableStyles'
import Disclaimer from '../Disclaimer/Disclaimer'
import { discountDisclaimer } from './PricingTable'

type MobilePricingTableProps = {
  account?: AccountFragment
  plans: Plan[]
  currentPlan?: string
  onSelect: (plan: string) => void
  getPlan: (planId: string) => PlanFragment | undefined
}

interface State {
  openPlans: Set<number>
}

export default class MobilePricingTable extends React.Component<
  MobilePricingTableProps,
  State
> {
  state: State = {
    openPlans: Set(),
  }

  togglePlan = (index: number) =>
    this.setState({
      openPlans: Selection.toggle(this.state.openPlans, index),
    })

  render() {
    const areFeaturesVisible = false
    const { plans, onSelect, getPlan } = this.props
    const visiblePlans = plans.filter(plan => plan.title !== 'Basic')
    return (
      <React.Fragment>
        {visiblePlans.map((plan: Plan, index: number) => (
          <React.Fragment key={plan.title}>
            <PlanTile
              plan={plan}
              isCurrentPlan={false}
              onSelect={onSelect}
              hideButton={true}
              getPlan={getPlan}
            />
            <RoundedFooter
              open={this.state.openPlans.contains(index)}
              actionTitle={'View Features'}
              onClick={() => this.togglePlan(index)}
              shouldDisclaimerBeVisible={false}
            />
            <Collapsible trigger="" open={this.state.openPlans.contains(index)}>
              <ul
                style={{
                  padding: '15px',
                  background: 'rgb(241, 241, 241)',
                  borderRadius: '5px',
                }}
              >
                {planDetails
                  .find(p => p.plan === plan.title)
                  ?.details.map(detail => (
                    <li
                      key={detail.detail}
                      style={{
                        ...{
                          listStyleType: 'none',
                          padding: '12px 0',
                          borderBottom: `${
                            detail.innerDetails ? 'none' : 'solid 1px #ccc'
                          }`,
                        },
                      }}
                    >
                      {detail.innerDetails && (
                        <>
                          <div style={{ fontWeight: 'bold' }}>
                            {detail.detail}
                          </div>
                          <ul>
                            {detail.innerDetails.map(innerDetail => (
                              <li
                                key={innerDetail.detail}
                                style={{
                                  ...{
                                    listStyleType: 'none',
                                    padding: '12px 0',
                                    borderBottom: 'solid 1px #ccc',
                                  },
                                }}
                              >
                                <li style={{ paddingLeft: '12px' }}>
                                  {innerDetail.detail}
                                </li>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                      {!detail.innerDetails && <li>{detail.detail}</li>}
                    </li>
                  ))}
              </ul>
            </Collapsible>
            {areFeaturesVisible && (
              <Collapsible
                trigger=""
                open={this.state.openPlans.contains(index)}
              >
                <React.Fragment>
                  {plan.categories &&
                    plan.categories.map((category: Category) => (
                      <React.Fragment key={category.title}>
                        <div
                          style={{
                            ...style.categoryHeader,
                            boxShadow,
                            background: '#fff',
                            margin: '0 3px',
                          }}
                        >
                          {category.title}
                        </div>
                        <React.Fragment>
                          {category.features.map(
                            (feature: any, index: number) => (
                              <Feature
                                key={feature.title}
                                id={index}
                                title={feature.title}
                                description={feature.description}
                                hasFeature={feature.hasFeature}
                                tooltipPosition={'left'}
                                hasBoxShadow={true}
                                value={
                                  feature.value !== feature.title
                                    ? feature.value
                                    : null
                                }
                                style={{
                                  background: categoryBackground,
                                }}
                              />
                            ),
                          )}
                        </React.Fragment>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              </Collapsible>
            )}
          </React.Fragment>
        ))}
        <Disclaimer messages={discountDisclaimer} />
      </React.Fragment>
    )
  }
}
